import React from "react";
import { View, Pressable } from "react-native";
import Text from "./AppText";
import AppSwitch from "./AppSwitch";
import tw from "twrnc";

const AppSwitchRow = ({
  isOn,
  onToggle,
  label,
  disabled = false,
  style,
  labelStyle,
}) => {
  return (
    <View
      style={[
        tw`flex-row items-center ml-0  py-3 border-b border-gray-200`,
        style,
      ]}
    >
      <View>
        <AppSwitch isOn={isOn} disabled={disabled} onToggle={onToggle} />
      </View>
      <Pressable
        style={tw`flex-1`}
        onPress={() => !disabled && onToggle(!isOn)}
      >
        <Text style={[tw`pl-2`, labelStyle]}>{label}</Text>
      </Pressable>
    </View>
  );
};

export default AppSwitchRow;
